import { WHEN_FILTERS } from '@spot/shared';
import { LayoutGrid, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Chip } from '../../components/ui/chip';
import { CATEGORY_SLUGS, CATEGORY_TEXT } from './categories';
import { CategoryIcon } from './category-icon';
import { toggle, type MapFilters as Filters } from './filters';

/** Time chips Зараз · Сьогодні · Завтра · Вихідні; tapping the active one clears it. Map: inside the «Фільтри» sheet (T-306a); Поруч: a row under the categories. */
export function WhenChips({
	value,
	onChange,
	className = '',
}: {
	value: Filters;
	onChange: (next: Filters) => void;
	className?: string;
}) {
	const { t } = useTranslation();
	return (
		<div role="group" aria-label={t('map.filters.when')} className={`flex gap-2 ${className}`}>
			{WHEN_FILTERS.map((when) => (
				<Chip
					key={when}
					selected={value.when === when}
					onClick={() => {
						onChange({ ...value, when: toggle(value.when, when) });
					}}
				>
					{t(`map.when.${when}`)}
				</Chip>
			))}
		</div>
	);
}

/** S1 category row (Усі + 8). On the map the time filters live in the «Фільтри» sheet (T-306a). */
export function MapFilters({
	value,
	onChange,
	mine = null,
}: {
	value: Filters;
	onChange: (next: Filters) => void;
	/** The «Мої» focus chip (T-1331), when the viewer has a pin in view; not a filter. */
	mine?: { focused: boolean; onToggle: () => void } | null;
}) {
	const { t } = useTranslation();
	return (
		<div
			role="group"
			aria-label={t('map.filters.category')}
			className="flex gap-2 overflow-x-auto px-4 py-1 [scrollbar-width:none]"
		>
			{mine !== null && (
				<Chip selected={mine.focused} onClick={mine.onToggle}>
					<Star aria-hidden="true" className="size-4" />
					{t('map.filters.mine')}
				</Chip>
			)}
			<Chip
				selected={value.category === undefined}
				onClick={() => {
					onChange({ ...value, category: undefined });
				}}
			>
				<LayoutGrid aria-hidden="true" className="size-4" />
				{t('map.filters.all')}
			</Chip>
			{CATEGORY_SLUGS.map((slug) => (
				<Chip
					key={slug}
					selected={value.category === slug}
					onClick={() => {
						onChange({ ...value, category: toggle(value.category, slug) });
					}}
				>
					<span className={value.category === slug ? 'text-text' : CATEGORY_TEXT[slug]}>
						<CategoryIcon slug={slug} />
					</span>
					{t(`categories.${slug}`)}
				</Chip>
			))}
		</div>
	);
}
